$('#forgotPassword').on('click', function(e) {
    e.preventDefault();
    var form = $(this).parents('form'),
        userID = form.find("#user_id")[0],
        forgotBox = form.find('#forgotBox')[0];

    if (userID.value == '') {
        forgotBox.value = 0;
        forgotBox.checked = false;
        alert("Please enter Username to proceed with Forgot Password.");
    } else {
        forgotBox.value = !0;
        forgotBox.checked = true;
        form.trigger('submit');
    }
});